import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { loadLocalization } from '@/services/localizationService';

Vue.use(VueI18n);

// Start with local translations as immediate fallback
const localTranslations = require('@/locales/en.json');

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: localTranslations
  }
});

/**
 * Initialize i18n with merged translations
 * Call this in your main.js after creating the Vue instance
 */
export const initializeI18n = async () => {
  try {
    const mergedTranslations = await loadLocalization();
    i18n.setLocaleMessage('en', mergedTranslations);
    return true;
  } catch (error) {
    console.error('Failed to initialize localization:', error);
    // Continue with local translations
    return false;
  }
};

export default i18n;
